import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, role, superadmin = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="text-slate-500 text-sm tracking-wider uppercase">Caricamento…</div>
      </div>
    );
  }

  if (superadmin) {
    if (!user || user.role !== "admin") return <Navigate to="/superadmin/login" replace />;
    return children;
  }

  if (!user) return <Navigate to="/" replace />;
  // Superadmin without a selected client must pick one first
  if (user.role === "admin" && !user.client_id) return <Navigate to="/superadmin" replace />;

  // Admin can access any route (including responsabile pages, to manage competitions)
  if (role && user.role !== role && user.role !== "admin") {
    return <Navigate to={user.role === "admin" ? "/admin" : "/responsabile"} replace />;
  }
  return children;
}
